module.exports = __webpack_public_path__ + "img/email-white-icon.9440a76b.svg";